import { render, staticRenderFns } from "./HealthService.vue?vue&type=template&id=2e136f50&scoped=true&"
import script from "./HealthService.vue?vue&type=script&lang=js&"
export * from "./HealthService.vue?vue&type=script&lang=js&"
import style0 from "./HealthService.vue?vue&type=style&index=0&id=2e136f50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e136f50",
  null
  
)

export default component.exports